import React from "react";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
const IlluminateCSVFileAdapterFieldSet = ({ config }) => {
  const { t } = useTranslation("enterprise_lookup");
  const valueLabel = config.multi_value_lookup ? t("adapter_fields.value_columns") : t("adapter_fields.value_column");
  const valueHelp = config.multi_value_lookup ? t("illuminate_csv_field_set.value_columns_help") : t("illuminate_csv_field_set.value_column_help");
  return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "path",
      name: "path",
      label: t("adapter_fields.file_path"),
      autoFocus: true,
      value: config.path,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      disabled: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "number",
      id: "check_interval",
      name: "check_interval",
      label: t("adapter_fields.check_interval"),
      required: true,
      help: t("illuminate_csv_field_set.help_check_interval"),
      value: config.check_interval,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      disabled: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "separator",
      name: "separator",
      label: t("adapter_fields.separator"),
      required: true,
      help: t("adapter_fields.help_separator"),
      value: config.separator,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      disabled: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "quotechar",
      name: "quotechar",
      label: t("adapter_fields.quote_character"),
      required: true,
      help: t("adapter_fields.help_quote_character"),
      value: config.quotechar,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      disabled: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "key_column",
      name: "key_column",
      label: t("adapter_fields.key_column"),
      required: true,
      help: t("adapter_fields.help_key_column"),
      value: config.key_column,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      disabled: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "value_column",
      name: "value_column",
      label: valueLabel,
      required: !config.multi_value_lookup,
      help: valueHelp,
      value: config.value_column,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9",
      disabled: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "multi_value_lookup",
      name: "multi_value_lookup",
      label: t("adapter_fields.multi_value_lookup"),
      checked: config.multi_value_lookup,
      help: t("adapter_fields.help_multi_value_lookup"),
      wrapperClassName: "col-md-offset-3 col-md-9",
      disabled: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "case_insensitive_lookup",
      name: "case_insensitive_lookup",
      label: t("adapter_fields.case_insensitive_lookup"),
      checked: config.case_insensitive_lookup,
      help: t("adapter_fields.help_case_insensitive_lookup"),
      wrapperClassName: "col-md-offset-3 col-md-9",
      disabled: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "checkbox",
      id: "cidr_lookup",
      name: "cidr_lookup",
      label: t("adapter_fields.cidr_lookup"),
      checked: config.cidr_lookup,
      help: t("adapter_fields.help_cidr_lookup"),
      wrapperClassName: "col-md-offset-3 col-md-9",
      disabled: true
    }
  ));
};
export default IlluminateCSVFileAdapterFieldSet;
